"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _reactScrollTrigger = _interopRequireDefault(require("react-scroll-trigger"));
var _reactRedux = require("react-redux");
var _actions = require("../actions");
var _halfImage = _interopRequireDefault(require("./half-image"));
var _halfText = _interopRequireDefault(require("./half-text"));
var _fiftyFifty = require("./fifty-fifty.propTypes");
var _fiftyFifty2 = _interopRequireDefault(require("../styles/fifty-fifty.css"));
var _lottieHotspotAnimation = require("@mmc/lottie-hotspot-animation");
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp,
  formatAsMKSPath = _DataUtils.formatAsMKSPath;

/**
 * ## FiftyFifty - component
 *
 * This component is to show image on one half os the page secton and text on the other half. It is configurable into multiple different views and themes
 */
var preparePromoForDataLayer = function preparePromoForDataLayer(promo, currentPath) {
  return {
    location_id: promo.locationId,
    promotion_id: promo.promotionId,
    promotion_name: promo.promotionName,
    layer: formatAsMKSPath(currentPath)
  };
};
var FiftyFifty = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(FiftyFifty, _React$Component);
  FiftyFifty.resourceType = function resourceType() {
    return 'FiftyFifty_1_0_0';
  };
  function FiftyFifty(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      showWholeImage: false
    };
    _this.publishPromoToDataLayer = _this.publishPromoToDataLayer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onProgressViewport = _this.onProgressViewport.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = FiftyFifty.prototype;
  _proto.onProgressViewport = function onProgressViewport(scrollInfo) {
    var interestPeriod = 0.2;
    var showWholeImage = this.state.showWholeImage;
    if (scrollInfo.progress > interestPeriod && showWholeImage === false) {
      this.setState({
        showWholeImage: true
      });
    }
  };
  _proto.getFourThreeMedium = function getFourThreeMedium(type) {
    if (type === 'text') {
      return 'col-sm-6';
    }
    return 'col-sm-6';
  };
  _proto.getOneOneMedium = function getOneOneMedium(type) {
    if (type === 'img') {
      return 'col-sm-4';
    }
    if (type === 'text') {
      return 'col-sm-8';
    }
    return '';
  };
  _proto.getOneOneSmall = function getOneOneSmall(type) {
    if (type === 'img') {
      return 'col-sm-5';
    }
    if (type === 'text') {
      return 'col-sm-7';
    }
    return '';
  };
  _proto.getOneOneLarge = function getOneOneLarge(type) {
    if (type === 'text') {
      return 'col-sm-6';
    }
    return 'col-sm-6';
  };
  _proto.getFourThreeLarge = function getFourThreeLarge(type) {
    if (type === 'text') {
      return 'col-sm-6';
    }
    return 'col-sm-6';
  }

  // This method just wraps the data utility function to pass in the
  // resourceType and data to check if it exists for this resourceType and if its valid data
  ;
  _proto.getColSize = function getColSize(aspect, size, type) {
    if (aspect === 'FourThree' && size === 'medium') {
      return this.getFourThreeMedium(type);
    }
    if (aspect === 'OneOne' && size === 'small') {
      return this.getOneOneSmall(type);
    }
    if (aspect === 'OneOne' && size === 'medium') {
      return this.getOneOneMedium(type);
    }
    if (aspect === 'OneOne' && size === 'large') {
      return this.getOneOneLarge(type);
    }
    if (aspect === 'FourThree' && size === 'large') {
      return this.getFourThreeLarge(type);
    }
    return 'col-sm-6';
  };
  _proto.publishPromoToDataLayer = function publishPromoToDataLayer() {
    var _this$props = this.props,
      promos = _this$props.promos,
      currentPath = _this$props.currentPath;
    window.dataLayer.push({
      event: 'view_promotion',
      promotiondata: promos.map(function (promo) {
        return preparePromoForDataLayer(promo, currentPath);
      })
    });
  };
  _proto.render = function render() {
    var _clsx, _clsx2, _clsx3;
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme,
      market = _this$props2.market;
    var showWholeImage = this.state.showWholeImage;
    var disclaimerData = data.disclaimerData;
    var hasText = !!(data != null && data.textBlock);
    if (data && data.aiHotspotInfo) data.aiHotspotInfo.zIndex = 5;
    return /*#__PURE__*/_react["default"].createElement(_reactScrollTrigger["default"], {
      throttleScroll: 50,
      onProgress: this.onProgressViewport
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme['container-fluid'], _fiftyFifty2["default"].noGutters, _fiftyFifty2["default"][data.size], (_clsx = {}, _clsx[_fiftyFifty2["default"].dark] = data.theme === 'dark', _clsx))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme.row, _fiftyFifty2["default"].noGutters)
    }, data.carAlignment && data.carAlignment === 'right' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme['col-xs-12'], theme[this.getColSize(data.aspectRatio, data.size, 'text')], _fiftyFifty2["default"].noGutters, _fiftyFifty2["default"].textWrap)
    }, /*#__PURE__*/_react["default"].createElement(_halfText["default"], {
      data: data,
      theme: theme,
      disclaimerData: disclaimerData,
      market: market,
      hasText: hasText
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme['col-xs-12'], theme['first-xs'], theme['last-sm'], theme[this.getColSize(data.aspectRatio, data.size, 'img')], _fiftyFifty2["default"].noGutters, _fiftyFifty2["default"].carRight, (_clsx2 = {}, _clsx2[_fiftyFifty2["default"].showWholeImage] = showWholeImage, _clsx2))
    }, data && data.aiHotspotInfo && /*#__PURE__*/_react["default"].createElement(_lottieHotspotAnimation.LottieHotspotAnimation, {
      data: data.aiHotspotInfo
    }), /*#__PURE__*/_react["default"].createElement(_halfImage["default"], {
      data: data,
      aspectRatio: data.aspectRatio,
      theme: theme,
      hasText: hasText
    }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme['col-xs-12'], theme[this.getColSize(data.aspectRatio, data.size, 'img')], _fiftyFifty2["default"].noGutters, (_clsx3 = {}, _clsx3[_fiftyFifty2["default"].showWholeImage] = showWholeImage, _clsx3))
    }, data && data.aiHotspotInfo && /*#__PURE__*/_react["default"].createElement(_lottieHotspotAnimation.LottieHotspotAnimation, {
      data: data.aiHotspotInfo
    }), /*#__PURE__*/_react["default"].createElement(_halfImage["default"], {
      data: data,
      aspectRatio: data.aspectRatio,
      theme: theme,
      carAlignment: data.carAlignment,
      hasText: hasText
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme['col-xs-12'], theme[this.getColSize(data.aspectRatio, data.size, 'text')], _fiftyFifty2["default"].noGutters, _fiftyFifty2["default"].textWrap)
    }, /*#__PURE__*/_react["default"].createElement(_halfText["default"], {
      data: data,
      theme: theme,
      disclaimerData: disclaimerData,
      market: market,
      hasText: hasText
    }))))));
  };
  return FiftyFifty;
}(_react["default"].Component);
FiftyFifty.displayName = 'FiftyFifty';
var mapStateToProps = function mapStateToProps(state) {
  return {
    promos: state.promos && state.promos.promos || [],
    market: state.Config.market
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(FiftyFifty);
exports["default"] = _default;